import React from 'react';
import Icon from '@material-ui/core/Icon';
import { posts } from '../funcs/posts';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import buildLink from "../funcs/buildlink";


export default class Menu extends React.Component{
  state = {
    show: false
  }

  componentDidMount(){
    var self = this;
    var ishome = document.getElementById('home');
    if(ishome){
      self.homeLogo();
      window.addEventListener('scroll', function(e){
        self.homeLogo();
      })
    }else{
      document.body.classList.add('show_logo');
    }

  }

  homeLogo(){
    try{
      var ty = document.getElementById('first').getBoundingClientRect().top;
      var s = ty <= 0;
      document.body.classList.toggle('show_logo', s);
    }catch{

    }


  }


  render(){

    var ishome = window.location.pathname == "/" || window.location.pathname == "/interactivo";

    var cs = ['menu'];
    if(this.state.show){
      cs.push('menu_showing');
    }

    var sections = [
      {
        name: 'Inicio',
        url: '',
        color: 'rgb(58, 187, 208)'
      },
      {
        name: 'Interactivo',
        url: 'interactivo',
        color: '#f00143'
      },
      {
        name: 'Textos',
        url: 'textos',
        color: '#f00143'
      },
      {
        name: 'Videos',
        url: 'videos',
        color: 'rgb(207, 207, 207)'
      },
      {
        name: 'Gráficos',
        url: 'graficos',
        color: '#f00143'
      }


    ]

    var posts_sections = [];

    // posts.map(function(p){
    //   posts_sections.push({
    //     name: p.title,
    //     url: p.slug,
    //     color: p.bg[0]
    //   })
    // })

    var postposts = [
      {
        name: 'Créditos',
        url: 'creditos',
        color: 'rgb(216, 227, 184)'
      }
    ];


    sections = [...sections, ...posts_sections, ...postposts];

    var self = this;
    console.log('whj', window.location.pathname)

    return(
      <>
      <div className={cs.join(' ')}>
        <div className="menu_row">
          <div className="menu_row_td first">
            <div className="menu_row_td_logo">
              <a href="https://animalpolitico.com" target="_blank">
                <img src={require('../static/ap.png')}/>
              </a>
            </div>
          </div>
          <div className="menu_row_td middle">

              <div className="menu_row_td_especial_logo">
                <a href={buildLink('/')}>
                  <img src={require('../static/lhc.png')} />
                </a>
              </div>


          </div>
          <div className="menu_row_td last">
            <div className="menu_row_td_burger" onClick={() => this.setState({show: !this.state.show})}>
              <Icon>{!this.state.show ? "clear_all" : "close"}</Icon>
            </div>
          </div>
        </div>
      </div>
      {
        this.state.show ?
        <div id="menu_drawer">
          <div id="menu_drawer_container">
            <div class="mdc_s">
              <a style={{marginLeft: '1rem', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 600, display: 'inline-block', padding:'0.35rem 0.5rem', backgroundColor: '#f00143', color: 'white', marginBottom: '1.5rem'}} href="https://www.animalpolitico.com/everyday-justice-mexico/">
                English version
              </a>
            </div>
            {
              sections.map(function(sect){
                var u = buildLink('/'+sect.url);
                if(ishome && sect.url == ""){
                  u = "#home";
                }
                if(ishome && sect.url == "interactivo"){
                  u = "#interactivo";
                }
                return(
                  <div className="mdc_s">
                    <a href={u} onClick={() => self.setState({show: false})}>
                      <div className="mdc_s_c" style={{borderColor: sect.color}}>
                        {sect.name}
                      </div>
                    </a>
                  </div>
                )
              })
            }
          </div>
        </div>
        : null
      }

      </>
    )
  }
}
